export const CLEAR_INSTRUMENT_LIST = 'query.clearInstrumentList';
export const FETCH_INSTRUMENT_LIST = 'query.fetchInstrumentList';
export const FETCH_INSTRUMENT_LIST_BY_SN = 'query.fetchInstrumentList.bySN';
export const SELECT_INSTRUMENT = 'query.selectInstrument';
export const INSTRUMENT_LIST_IS_UPDATING = 'query.InstrumentListUpdating';
export const FETCH_QUERY_PARAMS_META_DATA = 'query.fetchQueryParamsMetaData';
